const colors = {
  // New Colors (Lighter = Higher Number)
  blue_gray_100: '#D9E1E9',
  blue_gray_200: '#EDF4FC',
  blue_gray_300: '#F6F9FD',
  gray_100: '#333333',
  gray_200: '#666666',
  gray_300: '#999999',
  gray_350: '#C5C5C5',
  gray_400: '#EEEEEE',
  gray_1000: '#FAFAFA',
  yellow_200: '#FFC208',
  green_200: '#4CAF50',
  green_300: '#8DB367',
  green_400: '#B8E986',
  pink_200: '#F56276',
  red_200: '#D0021B',
  orange_200: '#FFA100',

  //Old Colors
  pink_light: '#FFDECE',
  pink: '#F09AB0',
  magenta: '#F06EB0',
  magenta_light: '#F03DB0',
  red_light: '#EE5044',
  red: '#EB011E',
  red_dark: '#B9011E',
  orange_yellow: '#FF9017',
  orange: '#FF5721',
  orange_red: '#FF4121',
  blue_brand: '#26D3EF',
  blue_brand_darker: '#2196F3',
  blue_light: '#00ADD1',
  blue: '#3473A9',
  blue_dark: '#1B2378',
  blue_desaturated: '#4251AF',
  green_light: '#00CA6C',
  green: '#00AF6C',
  green_dark: '#00996C',
  teal_green: '#00A494',
  teal: '#009EA4',
  teal_dark: '#00808A',
  purple_light: '#B367B0',
  purple: '#9C26B0',
  purple_blue: '#7626B0',
  purple_dark: '#39163D',
  purple_darkest: '#280A28',
  white: '#FFFFFF',
  gray_lightest: '#F4F4F4',
  gray_light: '#BDBDBD',
  gray: '#969696',
  gray_dark: '#646464',
  gray_darkest: '#323232',
  black: '#000000',
  brown_lightest: '#A18780',
  brown_light: '#8C6E63',
  brown: '#5C4038',
  brand_primary: '#14BCC9',
  brand_primary_hover: '#16CAD8',
  brand_primary_disabled: '#E0FAFC',
  brand_success: '#00AF6C',
  brand_success_hover: '#00965C',
  brand_success_disabled: '#63CBA3',
  brand_info: '#00ADD1',
  brand_info_hover: '#0098b8',
  brand_info_disabled: '#7DC5D4',
  brand_warning: '#FFC208',
  brand_warning_hover: '#EEB300',
  brand_warning_disabled: '#E1D2A5',
  brand_danger: '#EE5044',
  brand_danger_hover: '#EC3A2D',
  brand_danger_disabled: '#E6CECC',
  facebook: '#3B5998',
  twitter: '#00ACED',
  youtube: '#FF0000',
  instagram: '#517fa4',
  vimeo: '#45BBFF',
  promoboxx_blue: '#17BCC9',
}

export default colors
